import { combineReducers } from 'redux';
import authReducer from './authSlice';
import alertReducer from './alertSlice';
import gamerReducer from './gamerSlice';
import postReducer from './postSlice';
import messageReducer from './messageSlice';
import streamReducer from './streamSlice';

export default combineReducers({
  auth: authReducer,
  alert: alertReducer,
  gamer: gamerReducer,
  post: postReducer,
  message: messageReducer,
  stream: streamReducer,
});
